import { render, staticRenderFns } from "./checkSubject.vue?vue&type=template&id=13535911&scoped=true"
import script from "./checkSubject.vue?vue&type=script&lang=js"
export * from "./checkSubject.vue?vue&type=script&lang=js"
import style0 from "./checkSubject.vue?vue&type=style&index=0&id=13535911&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13535911",
  null
  
)

export default component.exports